import {
  CREATE_SCHEDULE,
  GET_ALL_SCHEDULE_LIST,
  GET_ALL_SCHEDULE_LIST_SUCESS,
  GET_DOCTORS_LIST,
  GET_DOCTORS_LIST_SUCCESS,
} from '../storeTypes';

export const ActionCreateSchedule = (payload, callBack) => {
  return {
    type: CREATE_SCHEDULE,
    payload,
    callBack,
  };
};
export const GetAllScheduleList = payload => {
  return {
    type: GET_ALL_SCHEDULE_LIST,
    payload,
  };
};
export const GetAllScheduleListSucess = payload => {
  return {
    type: GET_ALL_SCHEDULE_LIST_SUCESS,
    payload,
  };
};

export const GetDoctorsList = payload => {
  return {
    type: GET_DOCTORS_LIST,
    payload,
  };
};
export const GetDoctorsListSuccess = payload => {
  return {
    type: GET_DOCTORS_LIST_SUCCESS,
    payload,
  };
};
